const externalGutter = ["xsmall", "gutter", "xlarge"];
export {
  externalGutter
};
